import { createAsyncThunk } from '@reduxjs/toolkit';

import { RequestEnum } from '../request/model';
import { LegalEntityAPI } from 'integration/api/LegalEntity';

const getLegalEntity = createAsyncThunk(
  `legalEntity/${RequestEnum.getLegalEntity}`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await LegalEntityAPI.getLegalEntity();
      return data;
    } catch (error) {
      console.error('[getLegalEntity] Error: ', error);
      return rejectWithValue(error);
    }
  }
);

export const LegalEntityActions = { getLegalEntity };
